export default __webpack_public_path__ + "static/media/b4.c5f9439b.jpg";